<template>
  <div class="invoice-sending-report">
    <h6>Relatório de lotes enviados</h6>
    <div class="columns">
      <div class="column col-5 col-md-12 col-sm-12 form-group"
           :class="{'has-error': $v.filter.startDate.$error || $v.filter.endDate.$error}">
        <label class="form-label">Período</label>
        <st-date-period
          :start-date.sync="filter.startDate"
          :end-date.sync="filter.endDate"
          :start-date-validator="$v.filter.startDate"
          :end-date-validator="$v.filter.endDate"
          :max-months="4"
          @blur:startDate="$v.filter.startDate.$touch()"
          @blur:endDate="$v.filter.endDate.$touch()"
        />
      </div>
      <div class="column col-4 col-md-12 col-sm-12 form-group"
           :class="{'has-error': $v.filter.insurancePlanIds.$error}">
        <label class="form-label">Planos de saúde</label>
        <st-multi-select
          v-model="filter.insurancePlanIds"
          :items="insurances"
          @blur="$v.filter.insurancePlanIds.$touch()"
          value-key="id"
          label-key="name"
        />
      </div>
      <div class="column col-3 col-md-12 col-sm-12 form-group"
           :class="{'has-error': $v.filter.statuses.$error}">
        <label class="form-label">Status da fatura</label>
        <st-multi-select
          v-model="filter.statuses"
          :items="statusItems"
          value-key="value"
          label-key="label"
        />
      </div>
    </div>
    <div class="footer">
      <button class="btn btn-gray btn-icon btn-icon-left mr-1"
              :class="{loading: printing}"
              :disabled="printing"
              @click="print('sheet')">
        <fa-icon :icon="['fal', 'file-excel']"/>Gerar planilha
      </button>
      <button class="btn btn-primary btn-icon-left"
              :class="{loading: printing}"
              :disabled="printing"
              @click="print('pdf')">
        <fa-icon :icon="['fal', 'print']"></fa-icon>Imprimir
      </button>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { required, minLength } from 'vuelidate/lib/validators';
import { date, minDate } from '@/data/validators';
import formMixin from '@/mixins/form';
import { statuses as invoiceStatuses } from '@/data/invoice-statuses';

export default {
  mixins: [formMixin],
  data() {
    return {
      printing: false,
      insurances: [],
      filter: {
        startDate: '',
        endDate: '',
        insurancePlanIds: [],
        statuses: ['finished'],
      },
    };
  },
  validations() {
    const rules = {
      filter: {
        startDate: { date, required },
        endDate: { date, required },
        insurancePlanIds: { required, minLength: minLength(1) },
        statuses: { required, minLength: minLength(1) },
      },
    };

    if (this.filter.startDate) {
      rules.filter.endDate = {
        date,
        required,
        minDate: minDate(this.filter.startDate),
      };
    }

    return rules;
  },
  mounted() {
    this.loadInsurances();

    this.filter.startDate = moment()
      .startOf('month')
      .format('YYYY-MM-DD');
    this.filter.endDate = moment()
      .endOf('month')
      .format('YYYY-MM-DD');
  },
  computed: {
    statusItems() {
      return Object.keys(invoiceStatuses).map(key => ({
        value: key,
        label: invoiceStatuses[key],
      }));
    },
  },
  methods: {
    loadInsurances() {
      const params = {
        limit: 0,
        active: true,
      };
      return this.$http.get('/insurance-plans', { params })
        .then(({ data }) => {
          this.insurances = data.items.map(item => ({
            id: item.plan.id,
            name: item.customName,
          }));
        })
        .catch(() => {});
    },
    print(printType) {
      this.$v.filter.$touch();
      if (this.$v.filter.$error) {
        return false;
      }
      const diff = moment(this.filter.endDate)
        .diff(moment(this.filter.startDate), 'months');

      if (diff > 4) {
        this.$toast.show('Período máximo (4 meses)', { type: 'error' });
        return null;
      }

      this.printing = true;

      const params = {
        startDate: this.filter.startDate,
        endDate: this.filter.endDate,
        insurancePlanIds: this.filter.insurancePlanIds.join(','),
        printType,
        statuses: this.filter.statuses.join(','),
      };

      if (printType === 'sheet') {
        return this.$file
          .download('/reports/invoice-sending', params, {
            method: 'POST',
            name: 'relatório-lotes-enviados.xlsx',
          })
          .catch(() => {})
          .finally(() => {
            this.printing = false;
          });
      }

      return this.$file
        .print('/reports/invoice-sending', params, { method: 'POST' })
        .catch(() => {})
        .then(() => {
          this.printing = false;
        });
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/scss/_variables.scss';
  .invoice-sending-report {
    .footer {
      margin-top: $layout-spacing-lg;
      text-align: right;
    }
  }
</style>
